/**
 * Created by LifeSoft on 07/11/18.
 */
import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {DefaultApiService} from '../default-api.service';
import {Observable} from 'rxjs';
@Injectable()
export class StudentTranscriptResolver implements Resolve<any> {

  constructor(private defaultApi: DefaultApiService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    return this.defaultApi.getAll('api/v1/student-transcripts/basic-data');
  }

}
